import { useEffect, useRef, useState } from "react";
import useFade from "../../../MainComponents/Hooks/useFade";
import { useParams } from "react-router-dom";
import HelmetTags from "../../../MainComponents/HelmetTags";
import useAxios from "../../../MainComponents/Hooks/useAxios";
import Loader from "../../../MainComponents/Loader";
import SingleCourse from "../../../MainComponents/SingleCourse.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { useForm } from "react-hook-form";

function StudentCourse() {
  const [buyCourseByCode, setBuyCourseByCode] = useState({
    flag: "",
    dependency: false,
    data: {},
  });
  const [buyCourseByMobile, setBuyCourseByMobile] = useState({
    flag: "",
    dependency: false,
    data: {},
  });

  const { courseID } = useParams();
  const [reFetch, setReFetch] = useState(false);

  const TitleWrapper = useRef();
  const [fade] = useFade(TitleWrapper, 100);

  //!---- get all courses -------
  const [allCoursesData, allCoursesErrors, allCoursesLoading] = useAxios(
    `${process.env.REACT_APP_COURSES_API}/${courseID}`,
    "GET",
    courseID,
    reFetch
  );

  //!---- buy Course By Code -------
  const [
    buyCourseByCodeSuccess,
    buyCourseByCodeErrors,
    buyCourseByCodeLoading,
  ] = useAxios(
    process.env.REACT_APP_COURSES_BUY_API,
    "POST",
    buyCourseByCode.flag,
    buyCourseByCode.dependency,
    buyCourseByCode.data,
    true
  );

  //!---- buy Course By Mobile -------
  const [
    buyCourseByMobileSuccess,
    buyCourseByMobileErrors,
    buyCourseByMobileLoading,
  ] = useAxios(
    process.env.REACT_APP_PURCHASE_REQUESTS_API,
    "POST",
    buyCourseByMobile.flag,
    buyCourseByMobile.dependency,
    buyCourseByMobile.data,
    true
  );

  const {
    register: registerCode,
    handleSubmit: handleSubmitCode,
    formState: { errors: codeErrors },
    reset: resetCode,
  } = useForm({
    mode: "onTouched",
  });

  const {
    register: registerMobile,
    handleSubmit: handleSubmitMobile,
    formState: { errors: mobileErrors },
    reset: resetMobile,
  } = useForm({
    mode: "onTouched",
  });

  const handleBuyByCodeCourse = (data) => {
    setBuyCourseByCode({
      flag: "BuyByCode",
      dependency: !buyCourseByCode.dependency,
      data: { ...data, course_id: courseID },
    });
  };

  const handleBuyByMobileCourse = (data) => {
    setBuyCourseByMobile({
      flag: "BuyByMobile",
      dependency: !buyCourseByMobile.dependency,
      data: { ...data, id: courseID, type: "course" },
    });
  };

  useEffect(() => {
    if (buyCourseByCodeSuccess) resetCode();
    if (buyCourseByMobileSuccess) resetMobile();
    if (buyCourseByCodeSuccess || buyCourseByMobileSuccess) {
      setReFetch((prev) => !prev);
    }
  }, [buyCourseByCodeSuccess, buyCourseByMobileSuccess]);

  if (allCoursesLoading) return <Loader />;

  if (allCoursesErrors) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <p>{allCoursesErrors?.data?.response?.message}</p>
      </div>
    );
  }

  return (
    <section className="width mb-32 h-full dark:bg-dark dark:text-light">
      <HelmetTags title="افضل المحاضرات | مسيو بلال عبدالله " />
      <div ref={TitleWrapper} className="title-wrapper mt-36">
        <h2
          className={`mb-32 text-center text-5xl font-bold transition-all duration-300 ease-linear ${
            fade ? "translate-y-14 opacity-0" : "translate-y-0 opacity-100"
          } `}
        >
          أفضل المحاضرات
        </h2>

        {allCoursesData?.data?.is_purchased === false && (
          <div className="exam-details mx-auto mb-10 flex w-3/5 flex-col items-center gap-12 rounded-3xl bg-secondary text-white p-16 md:w-full">
            <div className="img-wrapper h-96 w-full cursor-pointer overflow-hidden rounded-3xl">
              <img
                className="h-full w-full object-cover duration-300 hover:scale-125"
                src={allCoursesData?.data?.course?.img}
                alt={allCoursesData?.data?.course?.title}
              />
            </div>

            <h2 className="text-4xl font-bold text-center">
              {allCoursesData?.data?.course?.title}
            </h2>
            <h3>{allCoursesData?.data?.course?.description}</h3>

            <div className="time-price flex w-3/4 items-center justify-between gap-5">
              <p className="flex h-10 w-fit items-center justify-center gap-1 rounded-xl bg-white text-secondary px-3 font-semibold">
                {allCoursesData?.data?.course?.price === 0 ? (
                  "مجاني"
                ) : (
                  <>
                    <span>ج.م </span>
                    <span>{allCoursesData?.data?.course?.price}</span>
                  </>
                )}
              </p>
            </div>

            <div className="course-contents w-full mt-6">
              <h4 className="text-2xl font-bold mb-4 text-center">
                محتويات الكورس
              </h4>
              <p className="mb-2 text-center">
                عدد المحاضرات: {allCoursesData?.data?.lectures?.length}
              </p>
              <ul className="list-disc list-inside space-y-2 text-xl leading-7">
                {allCoursesData?.data?.lectures?.map((lecture, index) => (
                  <li key={lecture.key || index}>
                    {lecture.title || `محاضرة ${index + 1}`}
                  </li>
                ))}
              </ul>
            </div>
            {allCoursesData?.data?.is_pending_request ? (
              <div className="flex flex-col items-center justify-center text-center py-16 animate-fade-in">
                <FontAwesomeIcon
                  icon={faSpinner}
                  spin
                  className="text-6xl text-yellow-400 mb-6 drop-shadow-md"
                />
                <p className="text-5xl md:text-3xl font-bold text-yellow-200 animate-pulse">
                  جاري مراجعة طلبك، سيتم الرد خلال 24 ساعة
                </p>
              </div>
            ) : (
              <div className="w-full">
                {allCoursesData?.data?.rejection_reason && (
                  <div className="w-full my-10 rounded-xl bg-red-600/30 p-6 shadow-md">
                    <p className="text-end text-2xl font-bold text-white mb-4 border-b border-white pb-2">
                      سبب رفض
                    </p>
                    <p className="text-end text-lg text-white leading-relaxed">
                      {allCoursesData?.data?.rejection_reason}
                    </p>
                  </div>
                )}

                <form
                  onSubmit={handleSubmitCode(handleBuyByCodeCourse)}
                  className="flex w-full flex-col items-start justify-center rounded-3xl shadow-lg"
                >
                  <div className="flex w-full flex-col items-center gap-4 md:w-full">
                    <label className="w-full text-center" htmlFor="code">
                      برجاء إدخال الكود السنتر الخاص بهذا الكورس
                    </label>
                    <input
                      className="signin-inputs w-full text-end"
                      type="text"
                      id="code"
                      placeholder="كود السنتر "
                      {...registerCode("code", {
                        required: true,
                        maxLength: 255,
                        minLength: 1,
                      })}
                    />
                    {codeErrors.code && (
                      <p className="mt-2 w-full text-end text-xl text-white">
                        {codeErrors.code.type === "required" &&
                          "برجاء ملئ هذا الحقل"}
                      </p>
                    )}
                    {buyCourseByCodeErrors?.response?.data?.errors?.code && (
                      <p className="w-full text-end text-[12px] text-white">
                        {buyCourseByCodeErrors?.response?.data?.errors?.code[0]}
                      </p>
                    )}
                  </div>

                  <button type="submit" className="submit max-w-60 mt-10">
                    {buyCourseByCodeLoading ? (
                      <FontAwesomeIcon icon={faSpinner} spin />
                    ) : (
                      "اشتري الكورس"
                    )}
                  </button>
                </form>

                <form
                  onSubmit={handleSubmitMobile(handleBuyByMobileCourse)}
                  className="flex w-full flex-col items-start justify-center rounded-3xl shadow-lg mt-12"
                >
                  <div className="flex w-full flex-col items-center gap-4 md:w-full">
                    <label
                      className="w-full text-center"
                      htmlFor="phone_number"
                    >
                      لشراء الكورس برجاء الشحن فودافون كاش على رقم 01001981209
                      وارسال رساله بالرقم الذى تم التحويل منه .{" "}
                    </label>
                    <input
                      className="signin-inputs w-full text-end"
                      type="tel"
                      id="phone_number"
                      placeholder="مثال: 01012345678"
                      {...registerMobile("phone_number", {
                        required: true,
                        pattern: /^01[0-9]{9}$/,
                      })}
                    />
                    {mobileErrors.phone_number && (
                      <p className="mt-2 w-full text-end text-xl text-white">
                        {mobileErrors.phone_number.type === "required" &&
                          "برجاء إدخال رقم الموبايل الذي تم التحويل منه"}
                        {mobileErrors.phone_number.type === "pattern" &&
                          "رقم الموبايل يجب أن يبدأ بـ 01 ويتكون من 11 رقم"}
                      </p>
                    )}
                    {buyCourseByMobileErrors?.response?.data?.errors
                      ?.phone_number && (
                      <p className="w-full text-end text-[12px] text-white">
                        {
                          buyCourseByMobileErrors?.response?.data?.errors
                            ?.phone_number[0]
                        }
                      </p>
                    )}
                  </div>

                  <button type="submit" className="submit max-w-60 mt-10">
                    {buyCourseByMobileLoading ? (
                      <FontAwesomeIcon icon={faSpinner} spin />
                    ) : (
                      "تأكيد رقم الموبايل"
                    )}
                  </button>
                </form>
              </div>
            )}
          </div>
        )}
      </div>

      <div
        className={`courses grid-auto-fit ${
          allCoursesData?.data?.is_purchased === false ? "!hidden" : ""
        }`}
      >
        {allCoursesData?.data?.lectures?.length === 0 ? (
          <p>لا يوجد محاضرات</p>
        ) : (
          allCoursesData?.data?.lectures?.map((card) => (
            <SingleCourse lecture={card} key={card.key} />
          ))
        )}
      </div>
    </section>
  );
}

export default StudentCourse;
